{
  "title": "Changelog",
  "description": "Manage public changelog entries visible to practitioners and institutions.",
  "addEntry": "New entry",
  "table": {
    "version": "Version",
    "date": "Date",
    "titleFr": "Title (FR)",
    "status": "Status",
    "actions": "Actions",
    "published": "Published",
    "draft": "Draft",
    "empty": "No changelog entries yet."
  },
  "form": {
    "createTitle": "New changelog entry",
    "createDescription": "Create a new version entry for the public changelog.",
    "editTitle": "Edit changelog entry",
    "editDescription": "Update an existing changelog entry.",
    "version": "Version",
    "releaseDate": "Release date",
    "isPublished": "Published",
    "title": "Title",
    "titlePlaceholder": "What's new in this version...",
    "highlights": "Highlights",
    "improvements": "Improvements",
    "fixes": "Fixes",
    "add": "Add",
    "remove": "Remove",
    "highlightIcon": "Icon",
    "highlightTitle": "Title",
    "highlightDescription": "Description",
    "improvementPlaceholder": "Describe the improvement...",
    "fixPlaceholder": "Describe the fix...",
    "french": "French",
    "english": "English",
    "cancel": "Cancel",
    "create": "Create",
    "save": "Save"
  },
  "delete": {
    "title": "Delete changelog entry",
    "description": "Are you sure you want to delete the entry for version {{version}}? This action cannot be undone.",
    "cancel": "Cancel",
    "confirm": "Delete"
  },
  "success": {
    "created": "Changelog entry created successfully",
    "updated": "Changelog entry updated successfully"
  },
  "errors": {
    "fetchFailed": "Failed to load changelog entries",
    "createFailed": "Failed to create changelog entry",
    "updateFailed": "Failed to update changelog entry",
    "deleteFailed": "Failed to delete changelog entry"
  }
}
